import "./facets";
import "./filter-drawer";
import "./content-spot";

class MainCollection extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (e) => {
      const loadMore = e.target.closest("[data-load-more]");

      if (!loadMore) return;

      e.preventDefault();

      const productGrid = this.querySelector("[data-product-grid]");

      fetch(loadMore.href)
        .then((response) => response.text())
        .then((response) => {
          const doc = new DOMParser().parseFromString(response, "text/html");

          const newLoadMore = doc.querySelector("[data-load-more]");
          if (!newLoadMore) {
            loadMore.style.display = "none";
            localStorage.setItem("collection-page-number", parseInt(loadMore.getAttribute('data-current-page'))+1);
          } else {
            loadMore.href = newLoadMore.href;
            localStorage.setItem("collection-page-number", newLoadMore.getAttribute('data-current-page'));
            loadMore.setAttribute('data-current-page', newLoadMore.getAttribute('data-current-page'));
          }

          productGrid.append(...doc.querySelectorAll("[data-product-card], content-spot"));
        });
    });
  }
}

if (!customElements.get("main-collection")) {
  customElements.define("main-collection", MainCollection);
}
